import { t } from '@lingui/macro';
import { RadioCard } from '@pocketlaw/tetris';
import { useField, useFormikContext } from 'formik';
import { Spacer } from './styled';
export function Fields() {
    const { isSubmitting } = useFormikContext();
    const [field] = useField('resolve');
    const RADIO_FIELDS = [
        {
            value: 'keep',
            title: t({
                message: 'Keep suggestions',
                comment: 'Plai Review - Resolve dialog - radio input title - keep suggestion',
            }),
            subtitle: t({
                message: 'Recommended',
                comment: 'Plai Review - Resolve dialog - radio input subtitle - keep suggestion',
            }),
        },
        {
            value: 'discard',
            title: t({
                message: 'Discard suggestions',
                comment: 'Plai Review - Resolve dialog - radio input title - keep suggestion',
            }),
            subtitle: t({
                message: 'Not recommended',
                comment: 'Plai Review - Resolve dialog - radio input subtitle - keep suggestion',
            }),
        },
    ];
    return (<Spacer>
      {RADIO_FIELDS.map(input => (<RadioCard checked={field.value === input.value} key={input.value} disabled={isSubmitting} {...field} {...input}/>))}
    </Spacer>);
}
